import {selectBreadcrumbsStringsBase} from '../../layout/breadcrumbs/breadcrumbs.utils';


export const selectBreadcrumbsStrings = selectBreadcrumbsStringsBase;

export function LayoutReducer(state = {}, action) {
}


